var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { value: _vm.value, persistent: "", width: "900" },
      on: {
        "click:outside": function($event) {
          return _vm.close()
        }
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "pl-6 pr-2 pt-4 pb-0" },
            [
              _c(
                "v-icon",
                { staticClass: "mr-2", attrs: { color: "warning" } },
                [_vm._v("mdi-alert")]
              ),
              _c("div", { staticClass: "title h6" }, [
                _vm._v(" Missing Linked Items Warning ")
              ])
            ],
            1
          ),
          _c(
            "v-container",
            { staticClass: "pa-0", attrs: { fluid: "" } },
            [
              _c("div", { staticClass: "mx-6 my-4" }, [
                _vm._v(
                  " At least one linked item is missing. Please review before proceeding. "
                )
              ]),
              _c("div", { staticClass: "mx-6 my-4" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      "Incomplete Linked Group(s): " +
                        _vm.missingLinkedGroupIds.join(", ")
                    ) +
                    " "
                )
              ]),
              _c("v-data-table", {
                staticClass: "mx-4",
                attrs: {
                  loading: _vm.loading,
                  items: _vm.missingLinkedItems,
                  headers: _vm.headers,
                  "no-data-text": "No missing linked items",
                  dense: "",
                  "fixed-header": "",
                  "disable-pagination": "",
                  "hide-default-footer": "",
                  "items-per-page": -1,
                  height: _vm.tableHeight
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "item.sale_price",
                      fn: function(ref) {
                        var item = ref.item
                        return [
                          item.sale_price
                            ? _c("span", [
                                _vm._v(
                                  "$" +
                                    _vm._s(
                                      _vm.$config.formatCurrency(
                                        item.sale_price
                                      )
                                    )
                                )
                              ])
                            : _c("span", [_vm._v("-")])
                        ]
                      }
                    },
                    {
                      key: "item.pack_size",
                      fn: function(ref) {
                        var item = ref.item
                        return [
                          item.pack_size
                            ? _c("span", [_vm._v(_vm._s(item.pack_size))])
                            : _c("span", [_vm._v("-")])
                        ]
                      }
                    }
                  ],
                  null,
                  true
                )
              }),
              _c(
                "div",
                { staticClass: "mt-4 d-flex justify-center" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "mb-4 mr-4",
                      attrs: { text: "" },
                      on: {
                        click: function($event) {
                          return _vm.close()
                        }
                      }
                    },
                    [_vm._v(" Cancel ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "mb-4",
                      attrs: { color: "warning" },
                      on: {
                        click: function($event) {
                          return _vm.confirm()
                        }
                      }
                    },
                    [_vm._v(" Confirm ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }